import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.search.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import searchSuggestionQuery from '~/graphql/searchSuggestion.gql';
import searchSuggestionAlgoliaQuery from '~/graphql/searchSuggestionAlgolia.gql';
import getCorvusProviderName from '~/helpers/search-data-helpers';
export default {
  props: {
    search: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      results: {},
      loading: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    isAlgoliaCorvusProvider: function isAlgoliaCorvusProvider() {
      return getCorvusProviderName(this) === 'algolia';
    },
    getAlgoliaIndex: function getAlgoliaIndex() {
      var algolia = this.$store.state.sharedEnv.payload.algolia;
      return algolia;
    }
  }),
  watch: {
    immediate: true,
    search: function search() {
      if (this.search.length === 0) this.results = {};
      this.debounceGetSuggestion();
    }
  },
  methods: {
    debounceGetSuggestion: debounce(function getSuggestions() {
      this.getResults();
    }, 200),
    getResults: function getResults() {
      if (this.isAlgoliaCorvusProvider) {
        return this.getAlgoliaCorvusSuggestions();
      }

      if (this.isAlgoliaCorvusProvider) {
        return this.getAlgoliaCorvusSuggestions();
      }

      return this.getSuggestions();
    },
    getAlgoliaCorvusSuggestions: function getAlgoliaCorvusSuggestions() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var algoliaUserToken, _yield$_this$$apolloP, _yield$_this$$apolloP2, categorySearchAlgolia, productSearchAlgoliaSuggest, products, totalProducts, categories, total;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this.search || _this.search.length < 3)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                algoliaUserToken = _this.$cookies.get('_ALGOLIA') || '';
                _this.loading = true;
                _context.prev = 4;
                _context.next = 7;
                return _this.$apolloProvider.defaultClient.query({
                  query: searchSuggestionAlgoliaQuery,
                  variables: {
                    locale: _this.locale.iso,
                    keyword: _this.search,
                    offset: 0,
                    limit: 5,
                    sortBy: 'POPULAR',
                    orderBy: 'DEFAULT',
                    filterBy: [],
                    algoliaUserToken: algoliaUserToken
                  }
                });

              case 7:
                _yield$_this$$apolloP = _context.sent;
                _yield$_this$$apolloP2 = _yield$_this$$apolloP.data;
                categorySearchAlgolia = _yield$_this$$apolloP2.categorySearchAlgolia;
                productSearchAlgoliaSuggest = _yield$_this$$apolloP2.productSearchAlgoliaSuggest;
                _this.loading = false;
                products = productSearchAlgoliaSuggest.products, totalProducts = productSearchAlgoliaSuggest.total;
                categories = categorySearchAlgolia;
                total = products.length + categories.length;
                _this.results = {
                  query: _this.search,
                  products: products,
                  categories: categories,
                  total: total,
                  totalProducts: totalProducts
                };
                _context.next = 22;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](4);
                _this.loading = false;

                _this.$logger.error(_context.t0);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 18]]);
      }))();
    },
    getSuggestions: function getSuggestions() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_this2$$apollo, _yield$_this2$$apollo2, categorySearch, productSearchSuggest, products, totalProducts, categories, total;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this2.search || _this2.search.length < 3)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _this2.loading = true;
                _context2.prev = 3;
                _context2.next = 6;
                return _this2.$apolloProvider.defaultClient.query({
                  query: searchSuggestionQuery,
                  variables: {
                    locale: _this2.locale.iso,
                    keyword: _this2.search,
                    offset: 0,
                    limit: 5,
                    sortBy: 'POPULAR',
                    orderBy: 'DEFAULT',
                    filterBy: []
                  }
                });

              case 6:
                _yield$_this2$$apollo = _context2.sent;
                _yield$_this2$$apollo2 = _yield$_this2$$apollo.data;
                categorySearch = _yield$_this2$$apollo2.categorySearch;
                productSearchSuggest = _yield$_this2$$apollo2.productSearchSuggest;
                _this2.loading = false;
                products = productSearchSuggest.products, totalProducts = productSearchSuggest.total;
                categories = categorySearch;
                total = products.length + categories.length;
                _this2.results = {
                  query: _this2.search,
                  products: products,
                  categories: categories,
                  total: total,
                  totalProducts: totalProducts
                };
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](3);
                _this2.loading = false;

                _this2.$logger.error(_context2.t0);

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 17]]);
      }))();
    }
  },
  render: function render() {
    return this.$scopedSlots.default({
      keyword: this.search,
      data: this.results,
      loading: this.loading
    });
  }
};